import { LoggingService } from './LoggingService.js';
import { create_overrides } from './types.js';
export var LoggingCategory;
(function (LoggingCategory) {
    LoggingCategory["METADATA"] = "metadata";
})(LoggingCategory || (LoggingCategory = {}));
/**
 * Logging System 🪵🪓.
 * @static
 * @example
 * Logger.setup(config);
 * Logger.debug('My message!');
 * Logger.as('My category').info('Another message');
 */
export class Logger {
    constructor() { }
    /**
     * Initiates `Logger` with a specified configuration.
     */
    static setup(config) {
        var _a;
        if (Logger._is_initialized) {
            console.warn('Logger is already initialized. Make sure to dispose Viewer/Logger before creating a new one.');
        }
        Logger._name = config.name;
        Logger._service = new LoggingService(Logger._name, (_a = config.rules) !== null && _a !== void 0 ? _a : []);
        Logger.setup_methods();
        Logger._is_initialized = true;
    }
    /**
     * Set `Logger` to be disabled or enabled.
     */
    static set_enabled(is_enabled) {
        LoggerSettings.is_enabled = is_enabled;
        Logger.setup_methods();
    }
    /**
     * Get `Logger` for a specified `category`.
     * @note Creates a new `category` if the `category` was not defined before.
     */
    static as(category) {
        let service = Logger._category_services.get(category);
        if (service) {
            return service;
        }
        service = new LoggingService(category, Logger._service.rules);
        Logger._category_services.set(category, service);
        return service;
    }
    /**
     * Create a new `category` and define new rules for it if necessary.
     * @example
     * Logger.add('My category').with_rules(category_rules);
     * Logger.as('My category').log('My message');
     */
    static add(category) {
        const service = new LoggingService(category, Logger._service.rules);
        if (this._category_services.has(category)) {
            throw new Error(`Category with name: ${category} already exists.`);
        }
        this._category_services.set(category, service);
        return {
            with_rules: (rules) => service.setup(rules)
        };
    }
    static only(category) {
        Logger.override(category, 'only');
        Logger.setup_methods();
    }
    static exclude(category) {
        Logger.override(category, 'exclude');
        Logger.setup_methods();
    }
    /**
     * Removes all existing overrides.
     */
    static clear_overrides() {
        LoggerSettings.overrides = null;
        Logger.setup_methods();
    }
    /**
     * Dispose the service.
     */
    static dispose() {
        Logger._category_services.clear();
        Logger._is_initialized = false;
    }
    static override(category, action) {
        category = Array.isArray(category) ? category : [category];
        if (!LoggerSettings.overrides) {
            LoggerSettings.overrides = create_overrides();
        }
        LoggerSettings.overrides.clear();
        LoggerSettings.overrides[action] = new Set(category);
    }
    static setup_methods() {
        this._service.update_methods();
        this._category_services.forEach(service => service.update_methods());
        Logger.log = Logger._service.log;
        Logger.debug = Logger._service.debug;
        Logger.info = Logger._service.info;
        Logger.warn = Logger._service.warn;
        Logger.error = Logger._service.error;
    }
}
Logger._is_initialized = false;
Logger._name = '';
Logger._category_services = new Map();
/**
 * @internal
 */
export class LoggerSettings {
    constructor() { }
}
LoggerSettings.is_enabled = true;
LoggerSettings.overrides = null;
//# sourceMappingURL=Logger.js.map